import React, {useState, useEffect, useLayoutEffect, useRef, useMemo} from 'react';
import {classNames} from 'primereact/utils';
import {Route, Routes, useLocation, Navigate, useNavigate, matchPath} from 'react-router-dom';
import AppConfig from './AppConfig';
import PrimeReact from 'primereact/api';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import './App.scss';
import CompaniesHeader from "./components/CompaniesHeader";
import {Login} from "./pages/Login";
import CompaniesList from "./components/Campaign/CompaniesList";
import NavigationMenu from "./components/Menu/NavigationMenu";
import Topbar from "./components/Menu/NavigationMenu/TopBar";
import {useAppDispatch, useAppSelector} from "./redux/hooks";
import {menuConfig, WSS_URL} from "./redux/config";
import UsersList from "./components/Settings/UsersList";
import BranchList from "./components/Branch/BranchList";
import {getRoleVision} from "./redux/api/apiRoles";
import {NotFound} from "./pages/NotFound";
import {Error} from "./pages/Error";
import Notifications from "./components/Notifications";
import {HubConnectionBuilder} from "@microsoft/signalr";
import * as signalR from "@microsoft/signalr";
import RolesList from "./components/Settings/RolesList";
import {setPendingRedirectPath, setUserStatusField} from "./redux/actions/actionsUser";
import {setFirstTabLogin, clearAllStates, hideError, hideErrorMessage} from "./redux/actions/actions";
import {setRolesVisible} from "./redux/actions/actionsRoles";
import StatusesList from "./components/Settings/StatusesList";
import {ERROR_ACCOUNT_WEB_LOGIN} from "./redux/types/types";
import QueueList from "./components/Queue/QueueList";
import {changeActiveTab, changeSession, stopGlobalJsSIP, registerHubConnection, unregisterHubConnection, stopAllHubConnections, terminateAllActiveCallsWithUserHeader} from "./components/JsSip/GlobalJsSIP";
import {getUserStatus, getUserStatuses} from "./redux/api/apiUsersList";
import {
    reconnectTab,
    setActiveSessionTab, setReconnectSession,
    setStatusHubError
} from "./redux/actions/actionsWebRTC";
import {setQueueMonitorStats} from "./redux/actions/actionsMonitoringList";
import QualificationGroupList from "./components/QualificationGroupList/QualificationGroupList/QualificationGroupList";
import {DecodedToken} from "./types/types";
import {jwtDecode} from "jwt-decode";
import {logHub, logLogout, logServerLogout, restoreUserConsoleLogsToStorage} from "./utils/appEventLogs";
// TEMP disabled for deploy: import {nextHubReconnectDelay} from "./utils/hubConnectionPolicy";
import {registerUnauthorizedLogout} from "./utils/httpStatusAuth";
import {clearSessionEndedNotice} from "./utils/sessionEndedNotice";
import MonitoringBranches from "./components/Monitoring/MonitoringBranches";
import TrunkList from "./components/Settings/TrunksList/TrunkList";
import IVRConfigurationList from "./components/Settings/IVRConfigurationList/IVRConfigurationList";
import AudioList from "./components/Settings/AudioList/AudioList";
import AudioControlList from "./components/Settings/AudioControlList/AudioControlList";
import AuthGoogle from "./components/AuthGoogle";
import AuthError from "./components/AuthError";
import RecoveryPass from "./components/RecoveryPass";
import RecoveryPassEmailPage from "./components/RecoveryPassEmailPage";
import StatisticsList from "./components/Statistics/StatisticsList";
import QualityControlStatisticsList from "./components/Statistics/QualityControlStatisticsList";
import CallsStatisticsList from "./components/Statistics/CallsStatisticsList";
import StatusStatisticsList from "./components/Statistics/StatusStatisticsList";
import TrunkStatisticsList from "./components/Statistics/TrunkStatisticsList";
import MonitoringDetailsWindow from "./components/Monitoring/MonitoringDetailsWindow";
import CallStatisticsDetailsWindow from "./components/Statistics/CallsStatisticsList/CallStatisticsDetailsWindow";
import DialerDetailsWindow from "./components/Campaign/DialerDetailsWindow";
import {getVoipDictionary} from "./redux/api/apiQueue";
import {getDialerDictionary} from "./redux/api/api";
import MonitoringQueue from "./components/Monitoring/MonitoringQueue";
import StatusesByPeriodList from "./components/Settings/StatusesByPeriodList";
import CampaignLeadsList from "./components/Statistics/CampaignLeadsList";
import IVRSchemePage from "./components/Settings/IVRConfigurationList/IVRSchemeSetting/IVRSchemePage";
function isCallCenterPublicPage() {
    if (typeof window === 'undefined') {
        return false;
    }
    const href = `${window.location.pathname || ''} ${window.location.hash || ''}`;
    return href.includes('/login') ||
        href.includes('forgotpassword') ||
        href.includes('pass/recovery') ||
        href.includes('auth_google') ||
        href.includes('authError/error');
}

const App = (props: any) => {
    const dispatch = useAppDispatch();
    const [configActive, setConfigActive] = useState(false);
    const [menuMode, setMenuMode] = useState('sidebar');
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [ripple, setRipple] = useState(true);
    const [sidebarStatic, setSidebarStatic] = useState(false);
    const [staticMenuDesktopInactive, setStaticMenuDesktopInactive] = useState(false);
    const [staticMenuMobileActive, setStaticMenuMobileActive] = useState(false);
    const [menuActive, setMenuActive] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const [profileMenuPin, setProfileMenuPin] = useState(false);
    const [headerTitle, setHeaderTitle] = useState<string>('Вихідні компанії');
    const copyTooltipRef = useRef<any>();
    const location = useLocation();
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const firstTabLogin = useAppSelector(state => state.UsersReducer.firstTabLogin);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as any;
    const statusCode = JSON.parse(localStorage.getItem('callcenter:accountWebLogin') || '{}');
    const rolesError = useAppSelector<any>(state => state.RolesReducer.error);
    const navigate = useNavigate();
    const [status, setStatus] = useState(null) as any;
    const [logoutUserId, setLogoutUserId] = useState(null) as any;
    const [statusHubConnection, setStatusHubConnection] = useState(null) as any;
    const [authGoogleQuery, setAuthGoogleQuery] = useState<boolean>(true);
    const [authGoogleErrorQuery, setAuthGoogleErrorQuery] = useState<boolean>(true);
    const [recoveryPass, setRecoveryPass] = useState<boolean>(() =>
        typeof window !== 'undefined' && (window.location.hash?.includes('pass/recovery?id') ||
            (window.location.pathname === '/pass/recovery' && (window.location.search?.includes('id=') || window.location.hash?.includes('id='))))
    );
    const [recoveryPassEmailPage, setRecoveryPassEmailPage] = useState<boolean>(() =>
        typeof window !== 'undefined' && (window.location.hash?.includes('auth/forgotpassword') || window.location.pathname === '/auth/forgotpassword')
    );
    const [statusHubConnectionState, setStatusHubConnectionState] = useState<any>(false);
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const token: string | any = sessionStorage.getItem('authToken');
    const expirationTime: string | any = sessionStorage.getItem('expirationTime') || localStorage.getItem('expirationTime');
    const isRecconectTab = useAppSelector(state => state.WebRTCReducer.reconnectTab);
    const [isActiveTab, setIsActiveTab] = useState(true);
    const [forceActiveTab, setForceActiveTab] = useState(false);
    const statusHubStartingRef = useRef(false);
    // TEMP disabled for deploy: statusHubConnectionRef / startStatusHubRef for the background-tab fix.
    const logoutStartedRef = useRef(false);
    const logoutRef = useRef<(reason: string, details?: Record<string, unknown>, broadcast?: boolean) => void>(() => {});
    const statuses = useAppSelector(state => state.UsersListReducer.statuses);
    const ivrConfigurationDisplayName = useAppSelector((s) => {
        const configuration = s.IVRConfigurationReducer.ivrConfigurationData?.configuration as
            | { name?: string | null }
            | undefined;

        return configuration?.name;
    });

    useLayoutEffect(() => {
        if (typeof window !== 'undefined') {
            if (!window.name) {
                window.name = `callcentre-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
            }

            const forceActive =
                sessionStorage.getItem('callCentreForceActiveWindowId') === window.name;
            if (forceActive) setForceActiveTab(true);

            const hash = window.location.hash || '';
            const isChildWindow =
                !!window.opener ||
                hash.includes('childWindow=1') ||
                window.location.search.includes('childWindow=1');

            if (isChildWindow && !forceActive) {
                setIsActiveTab(false);
                dispatch(setActiveSessionTab(false));
                return;
            }
        }

        changeActiveTab();
    }, [dispatch]);

    useEffect(() => {
        if (jwtToken?.jwtToken) {
            dispatch(hideError());
            dispatch(hideErrorMessage());

            dispatch(getVoipDictionary(jwtToken?.jwtToken));
            dispatch(getDialerDictionary(jwtToken.jwtToken));
        }
    }, [jwtToken?.jwtToken, dispatch]);

    useEffect(() => {
        if (!token) {
            const currentPath = location.pathname + location.search;
            if (currentPath !== '/' && currentPath !== '/login') {
                sessionStorage.setItem('pendingRedirect', currentPath);
                dispatch(setPendingRedirectPath(currentPath));
            }
        }
    }, [token, location]);

    useEffect(() => {
        if (!isActiveTab) {
            stopAllConnections();
            dispatch(setActiveSessionTab(false));
            dispatch(reconnectTab(false));
            dispatch(setReconnectSession(false));
        }
    }, [isActiveTab]);

    useEffect(() => {
        const handleStorage = (event: StorageEvent) => {
            if (event.key === 'callCentreActiveTab') {
                sessionStorage.removeItem('callCentreActiveTab');
                dispatch(setActiveSessionTab(false));
                // dispatch(setReconnectSession(false));
                // setIsActiveTab(false);
            } else if (event.key === 'queueMonitorStats' && event.newValue) {
                try {
                    const stats = JSON.parse(event.newValue);
                    dispatch(setQueueMonitorStats(stats));
                } catch (error) {
                    console.warn('Failed to parse queueMonitorStats from storage event:', error);
                }
            }
        };

        window.addEventListener('storage', handleStorage);
        return () => {
            window.removeEventListener('storage', handleStorage);
        };
    }, []);

    useEffect(() => {
        const token = sessionStorage.getItem('authToken');
        const isLoggedOut = sessionStorage.getItem('isLoggedOut');
        const localToken = localStorage.getItem('authToken');
        const localExpirationTime = localStorage.getItem('expirationTime');

        if (!token && !isLoggedOut && localToken && localExpirationTime) {
            sessionStorage.setItem('authToken', localToken);
            sessionStorage.setItem('expirationTime', localExpirationTime);
        }

        const hash = typeof window !== 'undefined' ? window.location.hash : '';
        const isPublicPage = location.pathname === '/login' || location.pathname === '/auth/forgotpassword' ||
            location.pathname === '/pass/recovery' ||
            hash?.includes('pass/recovery?id') || hash?.includes('auth/forgotpassword') ||
            hash?.includes('auth_google?id') || hash?.includes('authError/error');
        if (!token && !localToken && !isLoggedOut && !isPublicPage) {
            logLogout('missing_token_redirect_login');
            navigate('/login');
            sessionStorage.setItem('isLoggedOut', 'true');
        }
    }, [location.pathname, location.hash]);

    useEffect(() => {
        const isFirstTabLogin = sessionStorage.getItem('firstTabLogin') === 'true';
        dispatch(setFirstTabLogin(isFirstTabLogin));
    }, []);

    let decodedToken: DecodedToken;
    let decodedUserId: string | undefined;

    if (token || jwtToken?.jwtToken) {
        decodedToken = jwtDecode(token || jwtToken?.jwtToken);
        decodedUserId = decodedToken?.[`x-access-userid`]
    }

    let hash = window.location.hash;

    useEffect(() => {
        if (hash?.includes("auth_google?id")) {
            setAuthGoogleQuery(true);
        } else {
            setAuthGoogleQuery(false);
        }
    }, [hash]);

    useEffect(() => {
        if (hash?.includes("auth_google?id")) {
            setAuthGoogleQuery(true);
        } else {
            setAuthGoogleQuery(false);
        }
    }, []);

    useEffect(() => {
        if (hash?.includes("authError/error?notFound") || hash?.includes("authError/error?exist")) {
            setAuthGoogleErrorQuery(true);
        } else {
            setAuthGoogleErrorQuery(false);
        }
    }, [hash]);

    useEffect(() => {
        if (hash?.includes("authError/error?notFound") || hash?.includes("authError/error?exist")) {
            setAuthGoogleErrorQuery(true);
        } else {
            setAuthGoogleErrorQuery(false);
        }
    }, []);

    useEffect(() => {
        const fromHash = hash?.includes("pass/recovery?id");
        const fromPath = location.pathname === '/pass/recovery' && (location.search?.includes('id=') || hash?.includes('id='));
        setRecoveryPass(!!(fromHash || fromPath));
    }, [hash, location.pathname, location.search]);

    useEffect(() => {
        const isRecoveryPassEmail = hash?.includes("auth/forgotpassword") || location.pathname === '/auth/forgotpassword';
        setRecoveryPassEmailPage(!!isRecoveryPassEmail);
    }, [hash, location.pathname]);

    useEffect(() => {
        if (authGoogleQuery && jwtToken?.jwtToken) {
            if (statusCode === 300) {
                if (!rolesVision && rolesError === false && jwtToken?.jwtToken) {
                    dispatch(getRoleVision(jwtToken?.jwtToken));
                    dispatch(getVoipDictionary(jwtToken.jwtToken));
                    dispatch(getDialerDictionary(jwtToken.jwtToken));
                }

                if (rolesVision) {
                    const filteredMenuConfigWithRole = menuConfig.filter((item) =>
                        rolesVision.hasOwnProperty(item.name)
                    );
                    if (filteredMenuConfigWithRole.length) {
                        const order = rolesVision?.length ? Object?.keys(rolesVision) : [];

                        filteredMenuConfigWithRole?.sort((a, b) => {
                            const indexA = order?.indexOf(a.name);
                            const indexB = order?.indexOf(b.name);
                            return indexA - indexB;
                        });

                        if (filteredMenuConfigWithRole[0].name.toLowerCase() === 'campaigns') {
                            navigate(`/`);
                            localStorage.setItem('callcenter:accountWebLogin', '');
                            window.location.reload();
                        } else {
                            navigate(`/${filteredMenuConfigWithRole[0].name.toLowerCase()}`);
                            localStorage.setItem('callcenter:accountWebLogin', '');
                            window.location.reload();
                        }
                    }
                }

            }
        }
    }, [rolesVision, statusCode, rolesError, token]);

    const stopAllConnections = async () => {
        stopGlobalJsSIP();

        if (statusHubConnection) {
            try {
                statusHubConnection?.off("UpdateStatus");
                statusHubConnection?.off("Logout");
                statusHubConnection?.stop();
                unregisterHubConnection(statusHubConnection);
                setStatusHubConnection(null);
            } catch (error) {
                console.error("Error stopping statusHubConnection:", error);
            }
        }

        // Останавливаем все SignalR соединения
        await stopAllHubConnections().catch(error => {
            console.error("Error stopping hub connections:", error);
        });

        // Сбрасываем флаги состояния
        setStatusHubConnectionState(false);
        dispatch(setStatusHubError(true));
        statusHubStartingRef.current = false;
    };

    const logout = (reason: string, details?: Record<string, unknown>, broadcast = true) => {
        if (logoutStartedRef.current) {
            return;
        }
        logoutStartedRef.current = true;
        const alreadyLoggedOut = sessionStorage.getItem('isLoggedOut') === 'true';
        logLogout(reason, details);
        terminateAllActiveCallsWithUserHeader('logout');

        stopAllConnections();

        if (!authGoogleQuery) {
            navigate('/login');
        }

        sessionStorage.removeItem('authToken');
        sessionStorage.removeItem('expirationTime');
        sessionStorage.setItem('isLoggedOut', 'true');

        if (broadcast && !alreadyLoggedOut) {
            localStorage.removeItem('callcenter:user');
            localStorage.clear();
            localStorage.removeItem('persist:callcenter:user');
            localStorage.removeItem('expirationTime');
            localStorage.removeItem('authToken');
        }

        dispatch(clearAllStates());
        dispatch(setRolesVisible(null));
        dispatch({type: ERROR_ACCOUNT_WEB_LOGIN, payload: {"statusCode": null, "title": null, "message": null, "data": null}});
        restoreUserConsoleLogsToStorage();
    }
    logoutRef.current = logout;

    useLayoutEffect(() => {
        return registerUnauthorizedLogout((reason, details) => {
            logoutRef.current(reason, details);
        });
    }, []);

    const sessionKey = token || jwtToken?.jwtToken || null;
    const previousSessionRef = useRef(sessionKey);

    useEffect(() => {
        const previousSession = previousSessionRef.current;
        previousSessionRef.current = sessionKey;
        if (!previousSession && sessionKey) {
            clearSessionEndedNotice();
        }
    }, [sessionKey]);

    useEffect(() => {
        const onStorage = (event: StorageEvent) => {
            if (event.storageArea && event.storageArea !== localStorage) {
                return;
            }

            if (event.key === 'authToken' && event.newValue) {
                sessionStorage.setItem('authToken', event.newValue);
                logoutStartedRef.current = false;
                return;
            }

            const loggedOutElsewhere = (event.key === 'authToken' && event.newValue === null) || event.key === null;
            if (!loggedOutElsewhere || logoutStartedRef.current) {
                return;
            }

            logoutRef.current(event.key === null ? 'storage_cleared' : 'auth_token_removed_from_storage', undefined, false);
        };

        window.addEventListener('storage', onStorage);
        return () => window.removeEventListener('storage', onStorage);
    }, []);

    useEffect(() => {
        const timeout = expirationTime - Date.now();
        if (timeout > 0) {
            const timer = setTimeout(() => {
                logoutRef.current('session_expired', {source: 'expiration_timer', timeoutMs: timeout});
            }, timeout);

            return () => clearTimeout(timer);
        }
        if (sessionStorage.getItem('isLoggedOut') === 'true' || isCallCenterPublicPage()) {
            return;
        }
        logoutRef.current('session_already_expired', {source: 'expiration_timer', timeoutMs: timeout});
    }, [expirationTime]);

    useEffect(() => {
        const interval = setInterval(() => {
            const token = sessionStorage.getItem('authToken');
            const isLoggedOut = sessionStorage.getItem('isLoggedOut');
            const isPublicPage = isCallCenterPublicPage();

            const exp = parseInt(sessionStorage.getItem('expirationTime') || '0', 10);
            if (!exp || Date.now() > exp) {
                if (!isLoggedOut && !isPublicPage) {
                    logoutRef.current(!exp ? 'missing_expiration_poll' : 'session_expired_poll', {expirationTime: exp});
                }
                return;
            }

            if (!token) {
                if (!isLoggedOut && !isPublicPage) {
                    logoutRef.current('missing_token_poll');
                }
            } else {
                sessionStorage.removeItem('isLoggedOut');
                logoutStartedRef.current = false;
            }
        }, 1000);

        return () => clearInterval(interval);
    }, []);


    PrimeReact.ripple = true;

    let configClick: any;
    let menuClick: any;
    let searchClick: boolean = false;
    let pathname = location.pathname;

    const isDetailsPage = useMemo(() => {
        if (typeof window === 'undefined') {
            return false;
        }

        const hash = window.location.hash || '';
        const isChildWindow =
            !!window.opener ||
            hash.includes('childWindow=1') ||
            window.location.search.includes('childWindow=1');

        return isChildWindow && !forceActiveTab;
    }, [forceActiveTab]);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    useEffect(() => {
        setMenuActive(false);
    }, [menuMode]);

    useEffect(() => {
        const shouldLogout = !token && !authGoogleQuery && !authGoogleErrorQuery && !recoveryPass && !recoveryPassEmailPage;

        if (shouldLogout) {
            logout('missing_token');
        }

        if (!rolesVision && !rolesError && token) {
            dispatch(getRoleVision(token));
        }
    }, [token, authGoogleQuery, authGoogleErrorQuery, recoveryPass, recoveryPassEmailPage, rolesVision, rolesError]);

    const filteredMenuConfigWithRole = useMemo(() => {
        if (!rolesVision || !menuConfig) {
            return [];
        }

        const filterMenuItemsByRole = (items: any[]) => {
            if (!rolesVision || !items) {
                return [];
            }
            return items.reduce((acc, item) => {
                if (item?.items?.length) {
                    const filteredSubItems = filterMenuItemsByRole(item.items);
                    if (filteredSubItems.length) {
                        const canShowGroup = item.name === 'Settings'
                            || rolesVision?.hasOwnProperty(item.name)
                            || (item.name === 'Statistic' && rolesVision?.hasOwnProperty('QualityControlStatistic'));
                        if (canShowGroup) {
                            acc.push({...item, items: filteredSubItems});
                        }
                    }
                } else if (rolesVision?.hasOwnProperty(item.name)) {
                    acc.push(item);
                }
                return acc;
            }, []);
        };

        return filterMenuItemsByRole(menuConfig);
    }, [rolesVision]);

    const sortedMenuConfigWithRole = useMemo(() => {
        const order = rolesVision ? Object.keys(rolesVision) : [];
        const sorted = filteredMenuConfigWithRole?.slice().sort((a: {
            name: string;
        }, b: {
            name: string;
        }) => {
            const indexA = order.indexOf(a.name);
            const indexB = order.indexOf(b.name);
            return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
        });

        const settingsIndex = sorted?.findIndex((item: {
            name: string;
        }) => item.name === 'Settings');
        const statisticsIndex = sorted?.findIndex((item: {
            name: string;
        }) => item.name === 'Statistic');

        if (settingsIndex !== -1 && statisticsIndex !== -1 && statisticsIndex > settingsIndex) {
            const [statisticsItem] = sorted.splice(statisticsIndex, 1);
            sorted.splice(settingsIndex, 0, statisticsItem);
        }

        return sorted;
    }, [filteredMenuConfigWithRole, rolesVision]);

    const ivrSchemePageMatch = useMemo(
        () => !!matchPath({ path: "/ivr_scheme/:id", end: true }, location.pathname),
        [location.pathname]
    );

    const ivrSchemeHeaderDisplayTitle = useMemo(() => {
        if (!ivrSchemePageMatch) {
            return undefined;
        }

        const displayName = ivrConfigurationDisplayName?.trim();

        return displayName || "IVR схема";
    }, [ivrSchemePageMatch, ivrConfigurationDisplayName]);

    useEffect(() => {
        if (!rolesVision && statusCode === 200 && rolesError === false) {
            dispatch(getRoleVision(jwtToken?.jwtToken));
            dispatch(getVoipDictionary(jwtToken.jwtToken));
            dispatch(getDialerDictionary(jwtToken.jwtToken));
        }
    }, [rolesVision, rolesError]);

    const checkAccess = (routeName: string) => {
        if (routeName === "Monitoring") {
            return rolesVision?.hasOwnProperty(routeName) || rolesVision?.hasOwnProperty('Statistic');
        }
        return rolesVision?.hasOwnProperty(routeName);
    };

    const renderComponentOrRedirect = (routeName: string, component: any) => {
        return checkAccess(routeName) && token ? component : <Navigate to="/access"/>;
    };

    useEffect(() => {
        if (matchPath("/call_details/:id", pathname)) {
            setHeaderTitle("Деталі дзвінка");
            return;
        }
        if (matchPath("/campaign_details/:id", pathname)) {
            setHeaderTitle("Деталі кампанії");
            return;
        }
        if (matchPath({ path: "/ivr_scheme/:id", end: true }, pathname)) {
            setHeaderTitle("IVR схема");
            return;
        }
        switch (pathname) {
            case '/':
                setHeaderTitle('Вихідні кампанії');
                break;
            case '/monitoring':
                setHeaderTitle('Монiторинг Подiй');
                break;
            case '/branch':
                setHeaderTitle('Branch');
                break;
            case '/usersmanager':
                setHeaderTitle('Користувачі');
                break;
            case '/role':
                setHeaderTitle('Ролі користувачів');
                break;
            case '/status':
                setHeaderTitle('Статуси');
                break;
            case '/queue':
                setHeaderTitle('Вхідні черги');
                break;
            case '/skill_group':
                setHeaderTitle('Групи кваліфікацій');
                break;
            case '/trunks':
                setHeaderTitle('Транки');
                break;
            case '/audio_control':
                setHeaderTitle('Аудіоконтроль');
                break;
            case '/ivrconfiguration':
                setHeaderTitle('IVR Конфігурації');
                break;
            case '/audio':
                setHeaderTitle('Бібліотека аудіо');
                break;
            case '/statistics':
                setHeaderTitle('Дані дзвінків');
                break;
            case '/calls':
                setHeaderTitle('Дзвінки операторів');
                break;
            case '/statuses':
                setHeaderTitle('Статуси операторів');
                break;
            case '/call_details/:id':
                setHeaderTitle('Деталі дзвінка');
                break;
            case '/campaign_details/:id':
                setHeaderTitle('Деталі кампанії');
                break;
            case '/monitoring_queue':
                setHeaderTitle('Моніторинг Черг');
                break;
            case '/period_statuses':
                setHeaderTitle('Статуси оператора');
                break;
            case '/trunk_statistics':
                setHeaderTitle('Статистика транка');
                break;
            case '/leads':
                setHeaderTitle('Ліди кампанії');
                break;
            case '/quality_control':
                setHeaderTitle('Контроль якості');
                break;
            default:
                setHeaderTitle('callcenter')
        }
    }, [pathname]);

    useEffect(() => {
        const updateNetworkInfo = () => {
            const wasOnline = isOnline;
            const nowOnline = navigator.onLine;
            setIsOnline(nowOnline);

            if (wasOnline && !nowOnline) {
                console.log('[StatusHub] Network disconnected, stopping connections');
                stopAllConnections();
            }
        };

        window.addEventListener('online', updateNetworkInfo);
        window.addEventListener('offline', updateNetworkInfo);

        return () => {
            window.removeEventListener('online', updateNetworkInfo);
            window.removeEventListener('offline', updateNetworkInfo);
        };
    }, [isOnline]);

    const startConnection = (token: string) => {
        if (statusHubStartingRef.current) {
            return statusHubConnection;
        }

        if (statusHubConnection && statusHubConnection.state === 'Connected') {
            return statusHubConnection;
        }

        if (statusHubConnection && statusHubConnection.state === 'Connecting') {
            return statusHubConnection;
        }

        if (!token) {
            return null;
        }

        statusHubStartingRef.current = true;
        const connection = new HubConnectionBuilder()
            .withUrl(`${WSS_URL}StatusHub`, {
                skipNegotiation: true,
                transport: signalR.HttpTransportType.WebSockets,
                accessTokenFactory: () => token
            })
            .withAutomaticReconnect({
                nextRetryDelayInMilliseconds: (retryContext) => {
                    // TEMP disabled for deploy: nextHubReconnectDelay(retryContext.previousRetryCount)
                    if (retryContext.previousRetryCount < 12) {
                        return 5000;
                    }
                    return 30000;
                }
            })
            .configureLogging(signalR.LogLevel.None)
            .build();

        connection.serverTimeoutInMilliseconds = 60000;
        connection.keepAliveIntervalInMilliseconds = 15000;

        const invokeUserConnected = () => {
            try {
                connection.invoke("UserConnected", decodedToken?.[`x-access-userid`], "cc", firstTabLogin)
                    .then(() => {
                        dispatch(setStatusHubError(false));
                        dispatch(setFirstTabLogin(false));
                        sessionStorage.setItem('firstTabLogin', 'false');
                    })
                    .catch((error: any) => {
                        logHub('StatusHub', 'invoke_failed', {message: error?.message, method: 'UserConnected'});
                        dispatch(setStatusHubError(true));
                    });
            } catch (err: any) {
                logHub('StatusHub', 'invoke_failed', {message: err?.message, method: 'UserConnected'});
                console.error("Invoke error:", err);
            }
        };

        connection.onreconnected(() => {
            logHub('StatusHub', 'reconnected');
            console.log(`[${new Date().toISOString()}] Information: WebSocket reconnected to ${WSS_URL}StatusHub`);
            setStatusHubConnectionState('Connected');
            dispatch(getUserStatus(token));
            invokeUserConnected();
        });

        connection.onclose(() => {
            logHub('StatusHub', 'disconnected');
            console.log(`[${new Date().toISOString()}] Disconnected from ${WSS_URL}StatusHub`);
            setStatusHubConnectionState(false);
            dispatch(setStatusHubError(true));
            statusHubStartingRef.current = false;
        });

        connection.onreconnecting(() => {
            logHub('StatusHub', 'reconnecting');
            console.warn(`[${new Date().toISOString()}] Reconnecting to ${WSS_URL}StatusHub...`);
            setStatusHubConnectionState(false);
            dispatch(setStatusHubError(true));
        });

        connection
            .start()
            .then(() => {
                logHub('StatusHub', 'connected');
                if (!statuses?.length) {
                    dispatch(getUserStatuses(token));
                    dispatch(getUserStatus(token))
                }

                setStatusHubConnectionState('Connected');
                dispatch(setStatusHubError(false));

                connection.off("UpdateStatus");
                connection.off("Logout");

                connection.on("UpdateStatus", (updateStatus) => {
                    setStatus(JSON.parse(updateStatus));
                });

                connection.on("Logout", (serverMessage) => {
                    logServerLogout(serverMessage);
                    try {
                        setLogoutUserId(typeof serverMessage === 'string' ? JSON.parse(serverMessage) : serverMessage);
                    } catch (err) {
                        logHub('StatusHub', 'logout_parse_failed', {message: (err as any)?.message});
                    }
                });

                try {
                    const freshDecodedToken = jwtDecode(token);
                    // @ts-ignore
                    decodedUserId = freshDecodedToken?.[`x-access-userid`];
                } catch (err) {
                    logHub('StatusHub', 'jwt_decode_failed', {message: (err as any)?.message});
                    console.error("JWT decode error:", err);
                }

                invokeUserConnected();
                changeSession();
            })
            .catch((e) => {
                const isAbort = e?.name === 'AbortError' ||
                    (typeof e?.message === 'string' && e.message.includes('Failed to start the HttpConnection before stop() was called'));
                if (isAbort) {
                    return;
                }
                dispatch(setStatusHubError(true));
                setStatusHubConnectionState(false);
                if (!authGoogleQuery && !authGoogleErrorQuery && !recoveryPass && !recoveryPassEmailPage) {
                    logHub('StatusHub', 'failed', {message: e?.message});
                    console.error("Connection failed:", e);
                }
            })
            .finally(() => {
                statusHubStartingRef.current = false;
            });

        setStatusHubConnection(connection);
        registerHubConnection(connection);
        return connection;
    };
    // TEMP disabled for deploy: do not restart StatusHub when the tab becomes visible.

    let connection: any;

    useEffect(() => {
        const shouldStart = !authGoogleQuery && !authGoogleErrorQuery && !recoveryPass && !recoveryPassEmailPage;

        if (shouldStart) {
            if (!statusHubConnection || statusHubConnection.state === 'Disconnected') {
                // connection = startConnection();
            }

            return () => {
                try {
                    connection?.off?.("UpdateStatus");
                    connection?.off?.("Logout");
                } catch {}
                // if (connection?.state === 'Connecting') {
                //     setTimeout(() => connection?.stop?.(), 50);
                // } else {
                //     connection?.stop?.();
                // }
                unregisterHubConnection(connection);
            };
        } else {
            stopAllConnections();
        }
    }, [
        authGoogleQuery,
        authGoogleErrorQuery,
        recoveryPass,
        recoveryPassEmailPage,
        isRecconectTab,
        statusHubConnection?.state
    ]);

    useEffect(() => {
        if (!isOnline) return;

        const hasToken = sessionStorage.getItem('authToken') || jwtToken?.jwtToken;
        if (!hasToken) {
            if (statusHubConnection) {
                stopAllConnections();
            }
            return;
        }

        const isOnLoginPage = authGoogleQuery || authGoogleErrorQuery || recoveryPass || recoveryPassEmailPage;
        if (isOnLoginPage) {
            if (statusHubConnection) {
                stopAllConnections();
            }
            return;
        }

        if (!statusHubConnection || statusHubConnection.state === 'Disconnected') {
            if (statusHubStartingRef.current) {
                return;
            }

            const token = sessionStorage.getItem('authToken') || jwtToken?.jwtToken;
            const connection = startConnection(token || "");
            if (connection) {
                dispatch(setStatusHubError(false));
            }
        } else if (statusHubConnection && statusHubConnection.state === 'Connected') {
            dispatch(setStatusHubError(false));
        } else {
        }
    }, [isOnline, statusHubConnection?.state, jwtToken?.jwtToken, authGoogleQuery, authGoogleErrorQuery, recoveryPass, recoveryPassEmailPage]);

    useEffect(() => {
        if (!isOnline) return;

        const getStatusHubConnection = () => {
            const currentState = statusHubConnection?.state;

            setStatusHubConnectionState(
                currentState === 'Connecting' || currentState === 'Connected' ? currentState : false
            );

            if (isOnline) {
                const isConnectedOrConnecting = currentState === 'Connecting' || currentState === 'Connected';
                dispatch(setStatusHubError(!isConnectedOrConnecting));

                if (currentState === 'Disconnected' && !statusHubStartingRef.current) {
                    console.log('[StatusHub] Connection disconnected in interval, attempting direct reconnection...');
                    const token = sessionStorage.getItem('authToken') || jwtToken?.jwtToken;
                    startConnection(token || "");
                }
            } else {
                dispatch(setStatusHubError(true));
            }
        };

        const intervalId = setInterval(getStatusHubConnection, 3000);

        return () => {
            clearInterval(intervalId);
        };
    }, [isOnline, statusHubConnection?.state, jwtToken?.jwtToken, authGoogleQuery, authGoogleErrorQuery, recoveryPass, recoveryPassEmailPage]);

    useEffect(() => {
        if (status) {
            const outputObject: Record<string, any> = {};

            for (const key in status) {
                const newKey = key.charAt(0).toLowerCase() + key.slice(1);
                outputObject[newKey] = status[key];
                if (!outputObject.statusColor) {
                    outputObject.statusColor = '#616161'
                }
            }

            if (outputObject?.userId === decodedUserId) {
                dispatch(setUserStatusField(outputObject));
            }
        }
    }, [status]);

    useEffect(() => {
        if (logoutUserId) {
            const userLogout: Record<string, any> = {};

            for (const key in logoutUserId) {
                const newKey = key.charAt(0).toLowerCase() + key.slice(1);
                userLogout[newKey] = logoutUserId[key];
            }
            if (userLogout?.userId === decodedToken[`x-access-userid`]) {
                logout('server_force_logout', {userId: userLogout?.userId, payload: userLogout});
            }
        }
    }, [logoutUserId]);


    const onDocumentClick = () => {
        if (!searchClick && searchActive) {
            onSearchHide();
        }

        if (!menuClick) {
            if (isHorizontal() || isSlim()) {
                setMenuActive(false);
            }

            if (overlayMenuActive || staticMenuMobileActive) {
                setOverlayMenuActive(false);
                setStaticMenuMobileActive(false);
            }

            hideOverlayMenu();
            unblockBodyScroll();
        }

        if (configActive && !configClick) {
            setConfigActive(false);
        }

        menuClick = false;
        configClick = false;
        searchClick = false;
    };

    const onSearchHide = () => {
        setSearchActive(false);
        searchClick = false;
    };

    const onMenuModeChange = (menuMode: any) => {
        setMenuMode(menuMode);
        setOverlayMenuActive(false);
    };


    const onConfigClick = () => {
        configClick = true;
    };

    const onConfigButtonClick = (event: any) => {
        setConfigActive((prevState) => !prevState);
        configClick = true;
        event.preventDefault();
    };

    const onRippleChange = (e: any) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const hideOverlayMenu = () => {
        setOverlayMenuActive(false);
        setStaticMenuMobileActive(false);
    };

    const isHorizontal = () => {
        return menuMode === 'horizontal';
    };

    const isSlim = () => {
        return menuMode === 'slim';
    };

    const unblockBodyScroll = () => {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    };

    const profileMenuPinChange = (value?: boolean) => {
        if (value) {
            setProfileMenuPin(value);
        } else {
            setProfileMenuPin((prevState) => !prevState);
        }
    };

    const profileMenuPinClose = (active: any) => {
        setProfileMenuPin(active);
    };

    const layoutClassName = classNames('layout-wrapper', {
        'layout-static': menuMode === 'static',
        'layout-overlay': menuMode === 'overlay',
        'layout-overlay-active': overlayMenuActive,
        'layout-slim': menuMode === 'slim',
        'layout-horizontal': menuMode === 'horizontal',
        'layout-active': menuActive,
        'layout-mobile-active': staticMenuMobileActive,
        'layout-sidebar': menuMode === 'sidebar',
        'layout-sidebar-static': menuMode === 'sidebar' && sidebarStatic,
        'layout-static-inactive': staticMenuDesktopInactive && menuMode === 'static',
        'p-ripple-disabled': !ripple
    });

    const [sidebarActive, setSidebarActive] = useState(false);
    const [pinActive, setPinActive] = useState(false);
    const [resetActiveIndex, setResetActiveIndex] = useState<boolean>(false);
    const [topbarMenuActive] = useState(false);

    const onRootMenuItemClick = () => {
        setMenuActive((prevState) => !prevState);
    };

    const onSidebarMouseLeave = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setTimeout(() => {
                setSidebarActive(false);
                setPinActive(false);
            }, 250);
        }
    };

    const onMenuItemClick = (event: any) => {
        if (!event.item.items) {
            hideOverlayMenu();
            setResetActiveIndex(true);
        }

        if (!event.item.items && (isHorizontal() || isSlim())) {
            setMenuActive(false);
        }
    };

    const onToggleMenu = (event: any) => {
        menuClick = true;

        if (overlayMenuActive) {
            setOverlayMenuActive(false);
        }

        if (sidebarActive) {
            setSidebarStatic((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onMenuClick = () => {
        menuClick = true;
    };

    const onSidebarMouseOver = () => {
        if (menuMode === 'sidebar' && !sidebarStatic) {
            setSidebarActive(isDesktop());
            setTimeout(() => {
                setPinActive(isDesktop());
            }, 200);
        }
    };

    const onChangeActiveInlineMenu = (event: any) => {
        event.preventDefault();
    };

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    const onMenuButtonClick = (event: any) => {
        menuClick = true;

        if (isOverlay()) {
            setOverlayMenuActive((prevState) => !prevState);
        }

        if (isDesktop()) {
            setStaticMenuDesktopInactive((prevState) => !prevState);
        } else {
            setStaticMenuMobileActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const isOverlay = () => {
        return menuMode === 'overlay';
    };

    const closeMenu = () => {
        setStaticMenuMobileActive((prevState) => !prevState);
    }

    const [animationEnabled, setAnimationEnabled] = useState(false);

    const toggleAnimation = () => {
        setAnimationEnabled(!animationEnabled);
    };

    const [showSnow, setShowSnow] = useState(false);

    useEffect(() => {
        const isLoginPage = location.pathname === '/login' || location.hash === '#/login';
        if (isLoginPage) {
            return;
        }

        setShowSnow(false);

        const cssToRemove = document.getElementById('snow-css');
        const jsToRemove = document.getElementById('snow-js');
        const nyScriptToRemove = document.getElementById('NY_script-js');

        if (cssToRemove) {
            cssToRemove.remove();
        }
        if (jsToRemove) {
            jsToRemove.remove();
        }
        if (nyScriptToRemove) {
            nyScriptToRemove.remove();
        }

        (window as any).__SNOW_SCRIPTS_LOADED__ = false;

        // Удаляем все элементы, созданные скриптами
        const snowflakesBox = document.querySelector('.snowflakes-box');
        const snowballBox = document.querySelector('.snowball-box');
        const snowLayer = document.querySelector('.snow-layer');
        const snowballWrap = document.querySelector('.snowball-wrap');
        const snowPlowImg = document.querySelector('.snow-plow-img');

        if (snowflakesBox) {
            snowflakesBox.remove();
        }
        if (snowballBox) {
            snowballBox.remove();
        }
        if (snowLayer) {
            snowLayer.remove();
        }
        if (snowballWrap) {
            snowballWrap.remove();
        }
        if (snowPlowImg) {
            snowPlowImg.remove();
        }
    }, [location.pathname, location.hash]);

    useEffect(() => {
        setShowSnow(false);

        dispatch(hideError());
        dispatch(hideErrorMessage());

        const cssToRemove = document.getElementById('snow-css');
        const jsToRemove = document.getElementById('snow-js');
        const nyScriptToRemove = document.getElementById('NY_script-js');

        if (cssToRemove) {
            cssToRemove.remove();
        }
        if (jsToRemove) {
            jsToRemove.remove();
        }
        if (nyScriptToRemove) {
            nyScriptToRemove.remove();
        }

        (window as any).__SNOW_SCRIPTS_LOADED__ = false;

        // Удаляем все элементы, созданные скриптами
        const snowflakesBox = document.querySelector('.snowflakes-box');
        const snowballBox = document.querySelector('.snowball-box');
        const snowLayer = document.querySelector('.snow-layer');
        const snowballWrap = document.querySelector('.snowball-wrap');
        const snowPlowImg = document.querySelector('.snow-plow-img');

        if (snowflakesBox) {
            snowflakesBox.remove();
        }
        if (snowballBox) {
            snowballBox.remove();
        }
        if (snowLayer) {
            snowLayer.remove();
        }
        if (snowballWrap) {
            snowballWrap.remove();
        }
        if (snowPlowImg) {
            snowPlowImg.remove();
        }
    }, [token, dispatch]);

    return (
        <div className={!recoveryPass && !recoveryPassEmailPage ? layoutClassName : ''} onClick={onDocumentClick}>
            <Notifications/>

            {showSnow && (
                <div className="snowflakes" aria-hidden="true">
                    <div className="snowflake">
                        ❅
                    </div>
                    <div className="snowflake">
                        ❅
                    </div>
                    <div className="snowflake">
                        ❆
                    </div>
                    <div className="snowflake">
                        ❄
                    </div>
                    <div className="snowflake">
                        ❅
                    </div>
                    <div className="snowflake">
                        ❆
                    </div>
                    <div className="snowflake">
                        ❄
                    </div>
                    <div className="snowflake">
                        ❅
                    </div>
                    <div className="snowflake">
                        ❆
                    </div>
                    <div className="snowflake">
                        ❄
                    </div>
                </div>
            )}
            {token && rolesVision && !authGoogleQuery && !authGoogleErrorQuery && !recoveryPass && !recoveryPassEmailPage ?
                <div className="layout-main">
                    <Topbar
                        items={sortedMenuConfigWithRole}
                        menuMode={menuMode}
                        colorScheme={props.colorScheme}
                        menuActive={menuActive}
                        topbarMenuActive={topbarMenuActive}
                        onMenuButtonClick={onMenuButtonClick}
                        onSidebarMouseOver={onSidebarMouseOver}
                        onSidebarMouseLeave={onSidebarMouseLeave}
                        onToggleMenu={onToggleMenu}
                        onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                        onMenuClick={onMenuClick}
                        onMenuItemClick={onMenuItemClick}
                        onRootMenuItemClick={onRootMenuItemClick}
                        resetActiveIndex={resetActiveIndex}
                    />
                    <CompaniesHeader animationEnabled={animationEnabled} toggleAnimation={toggleAnimation} statusHubConnectionState={statusHubConnectionState} isDesktop={isDesktop} model={filteredMenuConfigWithRole} title={headerTitle}
                                     headerDisplayTitle={ivrSchemeHeaderDisplayTitle}
                                     customReloadClickItem={ivrSchemePageMatch ? "/ivrconfiguration" : undefined}
                                     profileMenuPinChange={profileMenuPinChange} profileMenuPin={profileMenuPin}
                                     setIsActiveTab={setIsActiveTab}
                                     isActiveTab={isActiveTab}
                                     showIconAsInactive={isDetailsPage}
                                     profileMenuPinClose={profileMenuPinClose}/>
                    <div
                        className={classNames(`layout-main-content transition-duration-300`, {'layout-main-content-profile-menu-active': profileMenuPin, 'sidebar-active': pinActive, 'layout-main-content-menu-active': sidebarStatic, 'p-0': pathname === '/404'})}>
                        <Routes>
                            <Route path="/" element={renderComponentOrRedirect("Campaigns", <CompaniesList/>)}/>
                            <Route path="/queue" element={renderComponentOrRedirect("Queues", <QueueList/>)}/>
                            <Route path="/role" element={renderComponentOrRedirect("Role", <RolesList/>)}/>
                            <Route path="/skill_group"
                                   element={renderComponentOrRedirect("SkillGroup", <QualificationGroupList/>)}/>
                            <Route path="/status" element={renderComponentOrRedirect("Status", <StatusesList/>)}/>
                            <Route path="/monitoring"
                                   element={renderComponentOrRedirect("Monitoring", <MonitoringBranches
                                       profileMenuPin={profileMenuPin}/>)}/>
                            <Route path="/monitoring_queue"
                                   element={renderComponentOrRedirect("QueueMonitor", <MonitoringQueue
                                       profileMenuPin={profileMenuPin}/>)}/>
                            <Route path="/branch" element={renderComponentOrRedirect("Branch", <BranchList
                                profileMenuPin={profileMenuPin}/>)}/>
                            <Route path="/usersmanager" element={renderComponentOrRedirect("Users", <UsersList
                                profileMenuPin={profileMenuPin}/>)}/>
                            <Route path="/trunks" element={renderComponentOrRedirect("Trunks", <TrunkList/>)}/>
                            <Route path="/audio_control" element={renderComponentOrRedirect("QualityControl", <AudioControlList/>)}/>
                            <Route path="/quality_control"
                                   element={renderComponentOrRedirect("QualityControlStatistic", <QualityControlStatisticsList
                                       profileMenuPin={profileMenuPin}/>)}/>
                            <Route path="/ivrconfiguration" element={renderComponentOrRedirect("IVRConfig", <IVRConfigurationList/>)}/>
                            <Route path="/statistics"
                                   element={renderComponentOrRedirect("Statistic", <StatisticsList
                                       profileMenuPin={profileMenuPin}/>)}/>
                            <Route path="/statuses"
                                   element={renderComponentOrRedirect("Statistic", <StatusStatisticsList
                                       profileMenuPin={profileMenuPin}/>)}/>
                            <Route path="/period_statuses"
                                   element={renderComponentOrRedirect("Statistic", <StatusesByPeriodList
                                       profileMenuPin={profileMenuPin}/>)}/>
                            <Route path="/trunk_statistics"
                                   element={renderComponentOrRedirect("Statistic", <TrunkStatisticsList
                                       profileMenuPin={profileMenuPin}/>)}/>
                            <Route path="/calls"
                                   element={renderComponentOrRedirect("Statistic", <CallsStatisticsList
                                       profileMenuPin={profileMenuPin}/>)}/>
                            <Route path="/audio" element={<AudioList/>}/>
                            <Route path="/leads" element={renderComponentOrRedirect("Campaigns", <CampaignLeadsList/>)}/>
                            <Route path="/ivr_scheme/:id" element={renderComponentOrRedirect("IVRConfig", <IVRSchemePage/>)}/>
                            <Route path="/error" element={<Error colorScheme={props.colorScheme}/>}/>
                            <Route path="/notfound" element={<NotFound colorScheme={props.colorScheme}/>}/>
                            <Route path="/call_details/:id" element={renderComponentOrRedirect("Monitoring", <MonitoringDetailsWindow />)} />
                            <Route path="/user_call_details/:id" element={renderComponentOrRedirect("Statistic", <CallStatisticsDetailsWindow />)} />
                            <Route path="/campaign_details/:id" element={renderComponentOrRedirect("Campaigns", <DialerDetailsWindow />)} />
                            <Route path="/*" element={<Navigate to="/notfound"/>}/>
                        </Routes>
                    </div>
                </div>
                : authGoogleQuery ? <AuthGoogle/> : authGoogleErrorQuery ? <AuthError/> : recoveryPass ?
                    <RecoveryPass/> : recoveryPassEmailPage ? <RecoveryPassEmailPage/> : <Login setIsActiveTab={setIsActiveTab}
                                                                                                isActiveTab={isActiveTab}/>}
            {token && !recoveryPass && !recoveryPassEmailPage && <NavigationMenu
                animationEnabled={animationEnabled}
                model={sortedMenuConfigWithRole}
                onRootMenuItemClick={onRootMenuItemClick}
                onMenuItemClick={onMenuItemClick}
                onToggleMenu={onToggleMenu}
                onMenuClick={onMenuClick}
                menuMode={menuMode}
                colorScheme={props.colorScheme}
                menuActive={menuActive}
                sidebarActive={sidebarActive}
                sidebarStatic={sidebarStatic}
                pinActive={pinActive}
                onSidebarMouseLeave={onSidebarMouseLeave}
                onSidebarMouseOver={onSidebarMouseOver}
                onChangeActiveInlineMenu={onChangeActiveInlineMenu}
                resetActiveIndex={resetActiveIndex}
                close={closeMenu}
                setShowSnow={setShowSnow}
            />}

            <AppConfig
                configActive={configActive}
                onConfigButtonClick={onConfigButtonClick}
                onConfigClick={onConfigClick}
                menuMode={menuMode}
                changeMenuMode={onMenuModeChange}
                colorScheme={props.colorScheme}
                changeColorScheme={props.onColorSchemeChange}
                theme={props.theme}
                changeTheme={props.onMenuThemeChange}
                componentTheme={props.componentTheme}
                changeComponentTheme={props.onComponentThemeChange}
                ripple={ripple}
                onRippleChange={onRippleChange}
            />
        </div>
    );
};

export default App;
